import useMediaQuery from '@mui/material/useMediaQuery';

const useMobileScreen = (width = 768):boolean => useMediaQuery(`(max-width:${width}px)`);

export default useMobileScreen;
